// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationCustomerLoyaltyPath = 'M63.536 36.895C75.011 42.063 83 53.598 83 67a33 33 0 01-33 33c-18.225 0-33-14.775-33-33 0-13.543 8.158-25.18 19.828-30.266L22.1 23.6a8.9 8.9 0 01-2-6.3 7.7 7.7 0 01.9-3.6v-.3L31.2 0h38.1l10.1 13.4.2.3a9.2 9.2 0 01-1.2 9.9l-.3.4-14.564 12.895zM38.036 21l4.166 11.127L29.75 21h8.286zm12.272 12.776L45.478 21h9.74l-4.91 12.776zm8.252-1.854L70.84 21h-8.117L58.56 31.922zM71.12 14L65.8 7h-7.425l4.797 7h7.948zm-16.48 0L50.4 7.8 46.445 14h8.194zm-16.524 0H29.45l5.25-7h7.862l-4.446 7zM91.6.5l-9.8 6.8 2.4 4.3L95 6.5l-3.4-6zm-7.4 24l10.8 5-3.4 6.1-9.8-6.9 2.4-4.2zm-65.9 4.2l-9.8 6.9L5 29.5l10.9-5 2.4 4.2zm-2.4-17.1L5 6.5l3.5-6 9.8 6.8-2.4 4.3zM50 41c-14.36 0-26 11.64-26 26s11.64 26 26 26 26-11.64 26-26c-.055-14.337-11.663-25.945-26-26z';
var IllustrationCustomerLoyalty = baseIllustration('IllustrationCustomerLoyalty', {
  getPath: () => IllustrationCustomerLoyaltyPath
});

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationCustomerLoyalty;
//# sourceMappingURL=index.js.map